/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 10:36:42
 * @Description: file content
 */ 
import React, { Component } from 'react';
import Tooltip from '../Tooltip';
import BillErrorTrack from '../BillErrorTrack';
import { getMultiLang, ViewModel } from '@platform/api';

const nameSpace = 'nccloud_platfrom_native_socket_billinfo';

require('./index.less');

export default class ErrorPop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBillTrack: false,
            json: {},
            LangData: null,
        };
    }

    componentWillMount() {
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData });
        };
        getMultiLang({ moduleId: 'base_errorTip', callback });
    }

    queryBillTrack = e => {
        console.log("触发红色按钮点击事件，e.target", e.target);
        this.setState({ showBillTrack: true });
    }

    doubleClick = event => {
        event.stopPropagation();
    }

    getBillInfo=()=>{
        let { record, name } = this.props;
        //获取ErrorPop组件参数
        let { billpkname, billtype, errorViewType, billtypeFromList, extraInfos = {} } = ViewModel.getData(nameSpace) || {};
        // 针对每行数据都不相同的单据类型，billtype值 从行数据上获取
        if (billtypeFromList && record[billtypeFromList] && record[billtypeFromList].value) {
            billtype = record[billtypeFromList].value;
        }
        if(extraInfos[name]){
            if(extraInfos[name].billtype) {billtype = extraInfos[name].billtype;}
            if(extraInfos[name].billpkname) {billpkname = extraInfos[name].billpkname;}
        }
        let saga_gtxid = record.saga_gtxid && record.saga_gtxid.value;
        let billpk = billpkname && record[billpkname] && record[billpkname].value;

        return{
            gtxid: saga_gtxid,
            billpk,
            billtype,
            errorViewType,
        };
    }

    render() {
        let { json } = this.state;
        let { gtxid, billtype, billpk, errorViewType } = this.getBillInfo();
        return (
            <div className="table-row-error-wrap" onDoubleClick={this.doubleClick}>
                <Tooltip delay={1} delayShow={800} inverse overlay={json['base-error-tip-0001'] || '点击查看错误原因'} trigger="hover" placement="top">
                    <span className="error-flag iconfont icon icon-gantanhao" onClick={this.queryBillTrack} />
                </Tooltip>

                <BillErrorTrack
                    show={this.state.showBillTrack}
                    close={() => {
                        this.setState({ showBillTrack: false });
                    }}
                    errorViewType={errorViewType}
                    pk={billpk} //单据id
                    type={billtype} //单据类型
                    gtxid={gtxid} //错误id
                // pk= "1001Z81000000001PYQH" //单据id
                // type='5F'  //单据类型
                // gtxid='2019110863519ada-eef2-4a47-93b5-446478d3d31b' //错误id
                // bodyClientHeight="500" //在第二层iframe里不用配置，如果iframe层更多，需要传一下body的高度
                />
            </div>

        );
    }
}